export enum GooglePaymentMethodType {
  Card = 'CARD',
  PayPal = 'PAYPAL',
}
